// get_notification
export const GET_NOTIFICATION = 'get_notification';
export const GET_NOTIFICATION_SUCCESSFUL = 'get_notification_successfull';
export const GET_NOTIFICATION_FAILED = 'get_notification_failed';

// create_notification
export const CREATE_NOTIFICATION = 'create_notification';
export const CREATE_NOTIFICATION_SUCCESSFUL = 'create_notification_successfull';
export const CREATE_NOTIFICATION_FAILED = 'create_notification_failed';

// update_notification
export const UPDATE_NOTIFICATION = 'update_notification';
export const UPDATE_NOTIFICATION_SUCCESSFUL = 'update_notification_successfull';
export const UPDATE_NOTIFICATION_FAILED = 'update_notification_failed';

// delete_notification
export const DELETE_NOTIFICATION = 'delete_notification';
export const DELETE_NOTIFICATION_SUCCESSFUL = 'delete_notification_successfull';
export const DELETE_NOTIFICATION_FAILED = 'delete_notification_failed';
